import { BrowserRouter as Router, Route, Routes } from 'react-router-dom';
import { AudioManagementProvider } from './context/AudioManagementContext';
import RouteLoggerContext from './context/RouteLoggerContext';
import { AuthProvider } from './context/AuthContext.js';
import Login from './page/Login.js';
import Invitation from './page/Invitation';
import Registry from './page/Registry';
import Attire from './page/Attire';
import Joan from './page/Joan';
import Error from './page/Error';

function App() {
  // lock the screen orientation if that's possible
  window?.screen?.orientation?.lock &&
    window.screen.orientation.lock('portrait-primary').catch((error) => {
      console.warn(error);
    });

  return (
    <AudioManagementProvider>
      <AuthProvider>
        <Router>
          <RouteLoggerContext />
          <Routes>
            <Route path="/login" element={<Login />} />
            <Route path="/" element={<Invitation />} />
            <Route path="/invitation" element={<Invitation />} />
            <Route path="/registry" element={<Registry />} />
            <Route path="/attire" element={<Attire />} />
            <Route path="/joan" element={<Joan />} />
            <Route path="/*" element={<Error />} />
          </Routes>
        </Router>
      </AuthProvider>
    </AudioManagementProvider>
  );
}

export default App;
